module.exports = __webpack_public_path__ + "static/img/TabunganSyariah.f3aabf7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/TabunganSyariah.png
// module id = nzIs
// module chunks = 36